<template>
  <div class="btn-group table-column-menu">
    {{ title }}

    <div class="table-column-menu-filter">
      <a href="javascript:;" :id="targetId">
        <i class="fa fa-filter" :class="{ 'text-muted': !filtedApplied }"></i>
      </a>
    </div>

    <div class="table-column-menu-sort">
      <slot name="sort">
      </slot>
    </div>

    <b-popover :target="targetId"
               triggers="click"
               :show.sync="popoverShow"
               placement="right"
               container="gridFiltersContainer"
               ref="popover">
      <div class="mhtable-filter-body">
          <label>Zobrazit položky kde datum a čas:</label>
            <b-form-select v-model="selectedDatefilterType" :options="datefilterOptions" class="mb-3" />
            <flat-pickr
                :config="flatPickerConfig"
                v-model="dateTime"                                                      
                class="form-control"
                :name="flatPickerName">
            </flat-pickr>
      </div>
      <div class="mhtable-filter-menu">
        <button type="submit" class="k-button k-primary" @click="search" aria-label="Search">Filtrovat</button>
        <button type="reset"  class="k-button" @click="reset" aria-label="Close">Zrušit</button>
      </div>
    </b-popover>

  </div>
</template>
<script>
export default {
  props: ['field', 'title', 'query'],
  data() { 
    return {
      dateTime: null,
      filtedApplied: false,
      popoverShow: false,
      targetId: 'filterMenuPopover' + this.field,
      flatPickerName: 'flatPicker' + this.field,
      selectedDatefilterType: 'eq',
      datefilterOptions: [
        { value: 'eq', text: 'Je rovno' },
        { value: 'neq', text: 'Není rovno' },
        { value: 'gte', text: 'Je větší nebo rovno' },
        { value: 'gt', text: 'Je vetší než' },
        { value: 'lte', text: 'Je menší nebo rovno' },
        { value: 'lt', text: 'Je menší než'},
        { value: 'isnull', text: 'Je nulové' },
        { value: 'isnotnull', text: 'Není nulové' }
      ],
      flatPickerConfig: {
            wrap: true,
            altFormat: 'd.m.Y H:i',
            dateFormat: 'd.m.Y H:i',
            enableTime: true,
            time_24hr: true,
            defaultDate: [new Date()],
            onChange: function(selectedDates, dateStr, instance) {
                 instance.close();
            },
      }
    }
  },
  mounted () {
    // this.$el.addEventListener('click', (event) => {
    //     //this.$refs.input.focus()
    // });
  },
  methods: {
    onClose () {
      this.popoverShow = false
    },
    search (e,reset) {
  
      let isReset = reset || false;

      if(this.dateTime){
        this.filtedApplied = true
      } else {
        this.filtedApplied = false
      }

      const { query } = this

      let filterObj = {
        "dataIndx": this.field,
        "value": this.dateTime,
        "condition": this.selectedDatefilterType,
        "dataType": "dateTime",
        "cbFn": ""
      }

      let filtered = query.filters.find(x => x.dataIndx === this.field)
      
      if(filtered != null && filtered != undefined){
        Object.assign(filtered, filterObj);
      } else if(isReset === false) {
        query.filters.push(filterObj);
      }

      query.offset = 0 
      this.onClose();
    },
    reset(){
      const { query } = this

      this.dateTime = null
      this.selectedDatefilterType = this.datefilterOptions[0].value

      let filtered = query.filters.filter(x => x.dataIndx !== this.field);
      query.filters = filtered;

      this.search(null,true)
    }
  }
}
</script>


<style>
  input[type=search]::-webkit-search-cancel-button {
    -webkit-appearance: searchfield-cancel-button;
    cursor: pointer;
  }
  .table-column-menu{
    width: 100%;
  }

  .table-column-menu-filter{
    text-align: right;
    position: absolute;
    right: 0;
  }
</style>
